<script setup lang="ts">
import {computed, useTemplateRef} from "vue";
import {ICellRendererParams} from "ag-grid-community";
import Translator from "@/utils/common/Translator.ts";
import NamaIcon from "@/components/icons/NamaIcon.vue";
import ColorUtils from "@/utils/common/ColorUtils.ts";

const {params} = defineProps<{ params: ICellRendererParams }>();
const metaData: namaTypes.BasicFieldMetaData = params["metaData"];
const namaIconRef = useTemplateRef<InstanceType<typeof NamaIcon>>("namaIconRef")
const fieldValue = computed(() => {
  const value = params.value;
  if (!value)
    return '';
  if (!metaData || !metaData.enumTypeName)
    return value;
  return Translator.translateId(metaData.enumTypeName + '.' + value);
});

const namaIconColor = computed(() => namaIconRef.value?.namaIconColor)
const isLightBg = computed(() => {
  if (!namaIconColor.value)
    return false;
  else
    return ColorUtils.isLightColor(namaIconColor.value);
})
</script>

<template>
  <div class="tw-flex tw-items-center tw-gap-2"
       :class="[namaIconRef?.hasColor?(isLightBg?'tw-text-gray-900 active-black':'tw-text-white active-white'):'']">
    <span v-if="namaIconRef?.hasColor" :style="{backgroundColor:namaIconRef?.namaIconColor}"
          class="tw-absolute tw-left-0 tw-top-0 tw-w-full tw-h-full -tw-z-10"/>
    <NamaIcon ref="namaIconRef" v-if="fieldValue" :enumTypeName="metaData.enumTypeName" :allowed-value="params.value"
              class="tw-size-[18px] !tw-text-[18px]"/>
    <span v-text="fieldValue" class="tw-overflow-hidden"/>
  </div>
</template>
